import { Link } from "react-router-dom";
import { formatPrecio, getLabelTipo } from "../../utils";
import { imgUrl } from "../../api";
import "./PropertyCard.css";

export default function PropertyCard({ propiedad }) {
  const {
    slug, title, operation, type, price, currency, show_price,
    price_negotiable, city, neighborhood,
    bedrooms, bathrooms, construction_m2, parking_spaces,
    featured, images,
  } = propiedad;

  const coverImg = images?.find((i) => i.is_cover) || images?.[0];
  const imgSrc = coverImg
    ? imgUrl(coverImg.url_thumb || coverImg.url)
    : null;

  return (
    <article className="prop-card fade-in">
      <Link to={`/propiedades/${slug}`} className="prop-card-img-wrap">
        {imgSrc ? (
          <img src={imgSrc} alt={title} className="prop-card-img" loading="lazy" />
        ) : (
          <div className="prop-card-no-img">🏠</div>
        )}
        <div className="prop-card-badges">
          <span className={operation === "VENTA" ? "badge-venta" : "badge-renta"}>
            {operation === "VENTA" ? "Venta" : "Renta"}
          </span>
          {featured && <span className="badge-featured">⭐ Destacada</span>}
        </div>
      </Link>

      <div className="prop-card-body">
        <p className="prop-card-price">
          {formatPrecio(price, currency, show_price)}
          {price_negotiable && show_price && (
            <span className="prop-card-negociable"> · A tratar</span>
          )}
        </p>
        <h3 className="prop-card-title">
          <Link to={`/propiedades/${slug}`}>{title}</Link>
        </h3>
        <p className="prop-card-location">
          📍 {neighborhood ? `${neighborhood}, ` : ""}{city}
        </p>
        <div className="prop-card-specs">
          <span className="prop-card-type">{getLabelTipo(type)}</span>
          {bedrooms != null && <span>🛏 {bedrooms} rec.</span>}
          {bathrooms != null && <span>🚿 {bathrooms} baños</span>}
          {construction_m2 != null && <span>📐 {construction_m2} m²</span>}
          {parking_spaces != null && <span>🚗 {parking_spaces}</span>}
        </div>
        <Link to={`/propiedades/${slug}`} className="btn btn-primary btn-sm prop-card-cta">
          Ver propiedad →
        </Link>
      </div>
    </article>
  );
}
